<template>
  <b-modal id="modal-request" ref="modal" size="lg" title="Request" @show="setData" @hidden="resetModal"
           @ok="handleOk">
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <div class="form-row">
        <label class="col-md-2">Date Range Overtime</label>
        <div class="col-md-3 mb-3">
          <div>
            <flat-pickr v-model="input_data.date" :config="config" ></flat-pickr>
          </div>
        </div>
      </div>
      <div class="form-row">
        <label class="col-md-2"></label>
        <div class="col-md-2 mb-3">
          <div>
            <flat-pickr  class="form-control" v-model="input_data.start" :config="config_time"  @on-change="countHours" @on-close="countHours"></flat-pickr>
          </div>
        </div>
        to
        <div class="col-md-2 mb-3">
          <div>
            <flat-pickr  class="form-control" v-model="input_data.end" :config="config_time" @on-change="countHours" @on-close="countHours"></flat-pickr>
          </div>
        </div>
        <div class="col-md-3 mb-3">
          <div class="input-group input-group-alt">
            <input type="text" class="form-control text-right" name="hours" :value="input_data.hours" id="hours" placeholder="" required readonly />
            <div class="input-group-append">
              <span class="input-group-text">Hours</span>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <label class="col-md-2" for="remarks">Remarks</label>
        <div class="col-md-9 mb-3">
          <textarea  class="form-control" id="remarks" placeholder="Remarks" name="remarks" v-model="input_data.remarks" required>
          </textarea>
        </div>
      </div>

      <list-supervisor module="overtime"  v-if="this.$store.getters.companySettings.is_ot_auto_approve == 0"></list-supervisor>

    </form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
        <button class="btn btn-warning float-right mr-1" @click="stat_id=1;handleOk($event)"> Submit </button>
        <button class="btn btn-primary float-right mr-1" @click="stat_id=0; handleOk($event)"> Save as Draft </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BModal} from "bootstrap-vue";
import ListSupervisor from "../employee/ListSupervisor";
import flatPickr from 'vue-flatpickr-component';
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";

export default {
  name: "OvertimeInput",
  components:{
    ListSupervisor,
    BModal,
    flatPickr
  },
  data(){
    return {
      config: {
        //wrap: true, // set wrap to true only when using 'input-group'
        static:true,
        altFormat: 'M j, Y',
        altInput: true,
        allowInput:false,
        dateFormat: 'Y-m-d',
      },
      config_time:{
        static:true,
        altFormat: 'H:i',
        allowInput: true,
        dateFormat: "H:i",
        noCalendar:true,
        enableTime:true,
        time_24hr:true,
      },
      stat_id:0,
      input_data:{
        date:"",
        start:"",
        end:"",
        hours:0,
        remarks:""
      }
    }
  },
  props:{
    data:{
      type:Object
    }
  },
  methods:{
    setData(){
      setTimeout(()=>{
        if(this.data !== null || Object.keys(this.data) > 0){
          this.input_data.date = this.data.date
          this.input_data.start = this.data.start
          this.input_data.end = this.data.end
          this.input_data.hours = this.data.duration
          this.input_data.remarks = this.data.reason
        }

      })
    },
    resetModal(){
      this.input_data = {
        date: "",
        start: "",
        end: "",
        hours: 0,
        remarks: ""
      }
      this.$parent.data = {}
      this.$refs.modal.hide();
    },
    handleOk(evt){
      evt.preventDefault()
      this.handleSubmit()
    },
    handleSubmit(){
      let userProfile = this.$store.getters.userProfile.data.attributes
      let payload = {
        stat_id :this.stat_id,
        date:this.input_data.date,
        start:this.input_data.start,
        end:this.input_data.end,
        duration:this.input_data.hours.replace("h ", ".").replace("m", ""),
        reason:this.input_data.remarks,
        unit_id: userProfile.emp_unit_id,
        position_id: userProfile.emp_position_id
      }

      if(this.data == null || Object.keys(this.data) < 1){
        AxiosCall.Post(payload, urlApi.overtime.add).then(res=>{
          if(res.success){
            this.$root.$children[0].successMessage(res.message)
            this.$parent.getData()
            this.$refs.modal.hide()
          }else {
            this.$root.$children[0].errorMessage(res.message)
          }
        }).catch(e=>{
          this.$root.$children[0].errorMessage(e.response.data.message)
        })
      }else {
        payload.id = this.data.id
        AxiosCall.Put(payload, urlApi.overtime.update).then(res=>{
          if(res.success){
            this.$root.$children[0].successMessage(res.message)
            this.$parent.getData()
            this.$refs.modal.hide()
          }else {
            this.$root.$children[0].errorMessage(res.message)
          }

        }).catch(e=>{
          this.$root.$children[0].errorMessage(e.response.data.message)
        })
      }
    },
    onCheck(){

    },
    countHours(selectedDate, dateStr){
      this.rangeHours()
    },
    rangeHours() {

      let time_start = this.input_data.start
      let time_end = this.input_data.end


      if(time_end !== "" && time_start !== ""){

        let tgl = new Date()

        let s = tgl.getFullYear()  + '-' + tgl.getDate() + '-' + tgl.getMonth(), e = tgl.getFullYear() + '-' + tgl.getDate() + '-' + tgl.getMonth()

        let start = new Date( s.split("-").reverse().join("/")+ " " + time_start)
        let end = new Date(e.split("-").reverse().join("/") + " " + time_end)

        let diff = end - start
        let hours = Math.floor((diff % 86400000) / 3600000)
        let minutes = Math.round(((diff % 86400000) % 3600000) / 60000)

        if(!isNaN(hours) && !isNaN(minutes)) this.input_data.hours = hours+"h "+minutes+"m"
      }
    },
    onValueUpdate(){
      console.log('abce')
    }
  }
}
</script>

<style >
.flatpickr-wrapper{
  width:100% !important;
  display: block;
}
</style>